import React, {useState} from 'react';

import MultipleTextPillComponent from '../../../multipleTextPillComponent/multipleTextPillComponent';
import MeetingRecipientsComponent from '../../../meetingRecipientsComponent/meetingRecipientsComponent';

import './anMeetingRecipientsComponent.css';

const AnMeetingRecipientsComponent = ({
  areAllEmailsValid = true,
  isEditIconClicked = false,
  currentUserId = '',
  newRecipientEmail = '',
  recipients = [],
  requester = {},
  setRecipientEmail = () => {},
  addRecipientEmail = () => {},
  editRecipientEmail = () => {},
  removeRecipient = () => {},
}) => {
  const [showAllGuestList, setShowAllGuestList] = useState(false);

  return (
    <div className="et-an-mrc-recipients-wrap">
      {isEditIconClicked ? (
        <MultipleTextPillComponent
          recipients={recipients}
          newRecipientEmail={newRecipientEmail}
          showError={!areAllEmailsValid}
          showStatusIcon={false}
          setNewRecipientEmail={setRecipientEmail}
          addRecipientEmail={addRecipientEmail}
          editRecipientEmail={editRecipientEmail}
          removeRecipient={removeRecipient}
        />
      ) : showAllGuestList ? (
        <MeetingRecipientsComponent
          currentUserId={currentUserId}
          recipients={recipients}
          requester={requester}
        />
      ) : (
        <div
          className="et-an-mrc-recipients-see-who-txt"
          onClick={() => {
            setShowAllGuestList(true);
          }}>
          See who’s joining
        </div>
      )}
    </div>
  );
};

export default AnMeetingRecipientsComponent;
